import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { Button, Grid, Header, Icon, Label, Loader, Popup, Table } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import ExamFilters from '../ExamTerms/ExamFilters';
import { toast, ToastContainer } from 'react-toastify';
import { ExportReactCSV } from '../../util/ExportCSV';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class ExamsByTerm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            id: null,
            name: null,
            loading: true,

            filterData: [],
            results: [],

            showFiltersOnButton: false,
            showFilterMode: null,


            documentNumber: null,
            inputDocNum: false,
            docNumErr: false,
            activeIndex: 0
        };

        this.getExams = this.getExams.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);
        this.filtersOff = this.filtersOff.bind(this);
        this.getFilterData = this.getFilterData.bind(this);
        this.activateFilter = this.activateFilter.bind(this);
        this.removeExam = this.removeExam.bind(this);
    }

    componentDidMount() {
        window.localStorage.removeItem('gradedActivityId');
        window.localStorage.removeItem('courseImplementationName');
        window.localStorage.removeItem('gradedActivityName');
        window.localStorage.removeItem('date');


        this.getExams(this.props.id);
    }

    getExams(id) {
        let obj = {};
        axios.post(`/exams/by-term/${id}`, { ...obj })
            .then(res => {
                this.setState({ data: res.data, loading: false, id });
            })
            .catch(err => {
                console.log('Failed to fetch exams');
            });
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        if (this.state.showFiltersOnButton) {
            return this.state.filterData;
        }
        return this.state.data;
    }

    getFilterData(courseImplementationName, gradedActivityTypeId, classroom, gradedActivityDate) {
        let docFilter = {};
        if (courseImplementationName) docFilter = { ...docFilter, courseImplementationName };
        if (gradedActivityTypeId) docFilter = { ...docFilter, gradedActivityTypeId };
        if (classroom) docFilter = { ...docFilter, classroom };
        if (gradedActivityDate) docFilter = { ...docFilter, gradedActivityDate };

        axios.post(`/exams/by-term/${this.props.id}`, { ...docFilter })
            .then(res => {
                const filterData = res.data;
                this.setState({ filterData, showFiltersOnButton: true, showFilterMode: false });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch filter results');
                toast('Došlo je do greške! Filtriranje nije uspjelo.');
            });
    }

    filtersOff() {
        this.setState({
            showFilterMode: false, showFiltersOnButton: false,
        });
        return this.state.data;
    }

    activateFilter() {
        this.setState({ showFilterMode: !this.state.showFilterMode });
    }

    removeExam(id) {
        let obj = {
            gradedActivity: { id },
            gradedActivityRegistrationDate: { id: localStorage.getItem('id') }
        };
        axios.get(`exams/staff/${id}`)
            .then(res => {
                if (res.data.length > 0) {
                    toast('Ispit se ne može obrisati. Morate ukloniti osoblje sa ispita.');
                } else {
                    axios.delete('/exams/delete', { data: obj })
                        .then(res => {
                            if (res.data === true) {
                                toast('Uspješno ste obrisali ispit.');
                                this.getExams(parseInt(localStorage.getItem('id'), 10));
                            }
                            if (res.data === false) {
                                toast('Ispit nije obrisan jer ima prijavljenih studenata.');
                            }
                        })
                        .catch(err => {
                            toast('Došlo je do greške! Brisanje ispita nije uspjelo.');
                        });
                }
            });
    }

    getResults(results) {
        this.setState({ results });
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>

                <Header style={IconHeader} floated="right" >
                    {this.state.showFiltersOnButton && <Button
                        onClick={this.filtersOff}
                        floated="left"
                        icon
                        labelPosition="right"
                        color="orange"
                        size="small"
                        style={FiltersOnStyle}
                    >
                        <Icon className="remove" onClick={this.filtersOff} />
                        Filtriranje uključeno!
                    </Button>}
                    <Icon />
                    <Popup
                        trigger={<Icon link circular basic="true" floated="right" name="filter" onClick={this.activateFilter} />}
                        content="Filtriranje podataka"
                        hideOnScroll
                        position="top center"
                    />
                </Header>

                {/*Backend filter*/}
                {/*{this.state.showFilterMode && <div>*/}
                {/*    <br />*/}
                {/*    <br />*/}
                {/*    <br />*/}
                {/*    <ExamFilters*/}
                {/*        getFilterData={this.getFilterData}*/}
                {/*        filtersOff={this.filtersOff}*/}
                {/*    />*/}
                {/*    <br />*/}
                {/*</div>}*/}

                {this.getDataToRender().length ? <Table celled selectable compact >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={18} >
                                <div style={{ paddingLeft: '30px' }}>
                                    <SearchTableData data={this.state.data} getResults={this.getResults} filterItem={['courseImplementationName', 'comment']} />
                                </div>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                            <Table.HeaderCell colSpan="8">Predmet</Table.HeaderCell>
                            <Table.HeaderCell colSpan="3">Tip ispita</Table.HeaderCell>
                            <Table.HeaderCell colSpan="3">Datum i vrijeme ispita</Table.HeaderCell>
                            <Table.HeaderCell colSpan="3"> Napomena</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>  {this.getDataToRender().map((el, index) =>
                        (<Table.Row >
                            <Table.Cell verticalAlign="middle" width={1}>
                                {(index + 1)}.
                            </Table.Cell >
                            <Popup
                                content={el.semesterNameKey === 'winter semester' ? 'Implementacija predmeta u zimskom semestru' : 'Implementacija predmeta u ljetnom semestru'}
                                hideOnScroll
                                position="left center"
                                trigger={<Table.Cell verticalAlign="middle" colSpan="8">
                                    <Grid columns={1} centered className="stackable">
                                        <Grid.Row verticalAlign="middle">
                                            <Grid.Column width="10">
                                                <span >  { el.semesterNameKey === 'winter semester' ? <Icon name="snowflake" color="blue" /> : <Icon name="sun" color="yellow" />}{el.courseImplementationName}</span>
                                            </Grid.Column>
                                            <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                {/* <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span> */}
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                </Table.Cell>}
                            />
                            <Table.Cell verticalAlign="middle" colSpan="3">
                                {el.gradedActivityName}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan="3">
                                {moment(el.gradedActivityDate).format('D. M. YYYY. - HH:mm')}
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle" colSpan="3">
                                {el.comment && <Label as="a" basic><Icon name="comment alternate outline" />{el.comment}</Label>}
                            </Table.Cell>
                        </Table.Row>))
                    }
                    </Table.Body>
                </Table> : <div><br />Nema ispita na ovom roku.</div>}

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/ExamsByTerm.js